<template>
  <div class="gameplan">
    <ContentHeader path-set-type="append" :gameplan-nav="false" />
    <div class="content-wrapper" v-loading="loading">
      <!-- 新建活动 -->
      <div class="activity_new">
        <div class="normal_title">活动主题信息</div>
        <div class="pr-box">
          <div class="pr-item space-between">
            <div class="pr-title"> {{themeBasic.themeName}} <span class="pr-level">{{ getOrgLevel }}</span> </div>
            <div> <span class="font-weight-bold">活动时间：</span> {{ themeBasic.themeStartTime | parseTime("{y}-{m}-{d}") }} {{themeBasic.themeStartTime?'-':''}}  {{ themeBasic.themeEndTime | parseTime("{y}-{m}-{d}") }} </div>
          </div>
          <!-- <div class="pr-item">
            <div style="margin-right:50px">PR信息：{{(themeBasic.gpPrDTO&&themeBasic.gpPrDTO.prNumber)+'_'+(themeBasic.gpPrDTO&&themeBasic.gpPrDTO.prName)}}</div>
            <div>品牌信息：{{getBrandInfo}}</div>
          </div> -->
          <div class="flex">
            <div style="margin-right:50px;margin-top:12px;"><span class="font-weight-bold">PR信息：</span>{{prInfo}}</div>
            <div style="margin-top:12px;"><span class="font-weight-bold">品牌信息：</span>{{brandInfo}}</div>
          </div>
          <div class="pr-item">
            <div style="margin-right:50px">活动执行数据收集模板 <el-button type="text" style="margin-left:10px;" @click="$refs['ConfigureExecutionData'].handleOpen()">配置详情</el-button></div>
            <div>
              <span>活动执行手册</span>
              <el-button v-if="themeBasic.manualFileName" type="text" style="margin-left:10px;" @click="openFile('manualFileUri')">{{ themeBasic.manualFileName }}</el-button>
              <el-button type="text" style="margin-left:10px;" v-else>暂无附件</el-button>
            </div>
          </div>
        </div>

        <div class="normal_title">{{getName(themeDetail.themeChannelName)}}</div>
        <div class="operation_btn_box">
          <div class="operate_btn operate_btn_white" @click="handleReset()">重置</div>
        </div>
        <ActivityChangeAssignItem :isOwner="isOwner" ref="ActivityChangeAssignItem" :itemIndex="index" @handleSubAssignList="handleSubAssignList" :assignCodeList="assignCodeList" :typeKey="typeKey" v-for="(item,index) of detailList" :itemInfo="item" :key="index"/>
      </div>

      <div class="btn_section">
        <div class="normal_btn btn_bg_white" @click="cancel()">取消</div>
        <div class="normal_btn btn_bg_red"  @click="submit()">提交变更</div>
      </div>
    </div>

    <ConfigureExecutionData class="configure-execution" ref="ConfigureExecutionData"  :readonly="true" :themeId="themeId"></ConfigureExecutionData>
  </div>
</template>

<script>
import gameplanApi from "@/api/gameplan";
import { commonUtils } from '@/utils/common'
import { mapGetters,mapState } from 'vuex'
import ContentHeader from "@/components/content-header";
import ConfigureExecutionData from './components/configure-execution-data'
import ActivityChangeAssignItem from './components/activity-change-assign-item.vue'
export default {
  name: 'ActivityChangeAssign',
  components: {
    ContentHeader,
    ConfigureExecutionData,
    ActivityChangeAssignItem
  },
  data() {
    return {
      themeId:'',
      themeChannelCode:'',
      themeBasic:{},
      loading:false,
      detailList:[],
      typeKey:'key',
      assignCodeList:[],
      themeDetailVOList:[],
      valid:0,
      themeDetail:{},
      prInfo:'',
      brandInfo:''
    };
  },
  created(){
    this.employeeLevel = this.userInfo.employeeLevel
    if(this.isHQ) this.$store.dispatch('getGameplanCityPoolBaseOrgBuList')
    else if(this.isBU) this.$store.dispatch('getGameplanCityPoolBaseOrgRegionList',{buOrgId:this.userInfo.orgDTO.parentOrgId})
    else if(this.isRegion) this.$store.dispatch('getThemeRegionList')
    this.themeChannelCode = this.$route.query.themeChannelCode
    this.themeId = this.$route.query.themeId
    this.getGameplanThemeNewDetailList()
  },
  watch:{
    buList(){
      this.assignCodeList = this.buList
    },
    regionList(){
      this.assignCodeList = this.regionList
    },
    regionOrgList(){
      this.assignCodeList = this.regionOrgList
    }
  },
  mounted() {
    //this.$nextTick(()=>{
      if(this.isHQ) {
        this.assignCodeList = this.buList || []
        this.typeKey='buCode'
      }else if(this.isBU) {
        this.assignCodeList = this.regionList || []
        this.typeKey='regionCode'
      }else if(this.isRegion) {
        this.assignCodeList = this.regionOrgList || []
        this.typeKey='regionCode'
      }
   // })
  },
  computed:{
    ...mapGetters(['userInfo']),
    ...mapState({
      buList: state => state.gameplan.buList,
      regionList: state => state.gameplan.regionList,
      areaList: state => state.gameplan.areaList,
      regionOrgList: state => state.gameplan.regionOrgList
    }),
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    getBrandInfo(){
      const gpPrDTO = this.themeBasic.gpPrDTO
      if(gpPrDTO){
        if(gpPrDTO.brandName&&gpPrDTO.subBrandName){
          return gpPrDTO.brandName+'-'+gpPrDTO.subBrandName
        }else return gpPrDTO.brandName||gpPrDTO.subBrandName
      }else return '暂无'
    },
    getOrgLevel(){
      if(this.themeBasic.orgLevel&&this.themeBasic.orgLevel.length===2) return this.themeBasic.orgLevel.toUpperCase()
      else return 'Region'
    },
    isOwner(){
      return this.userInfo.employeeCode===this.themeBasic.themeOwnerCode
    },
  },
  methods: {
    async getGameplanThemeNewDetailList() {
      const params = {
        themeChannelCode:this.themeChannelCode,
        themeId:this.themeId
      }
      console.log(params);
      const res = await gameplanApi.getGameplanThemeNewDetailList(params);
      if (res.data.resultCode === "0") {
        this.themeDetail= res.data.resultData.detailList[0].themeDetail || {}
        this.detailList = res.data.resultData.detailList || []
        this.themeBasic =  res.data.resultData.themeBasic || {}
        this.getShowDetail()
      }
      this.loading = false
    },
    openFile(type){
      if(type === 'execTemplateUri'){
        window.open(commonUtils.getImageUrl(this.themeBasic.execTemplateUri))
      }else if(type === 'manualFileUri'){
        window.open(commonUtils.getImageUrl(this.themeBasic.manualFileUri))
      }
    },
    handleSubAssignList(item,index,valid){
      this.themeDetailVOList[index] = item
      if(valid) this.valid++
      if(this.valid===this.detailList.length) {
        this.valid = 0
        this.$confirm('是否确认修改配额?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-red',
          type: 'warning'
        }).then(() => {
          this.handleThemeRelocation()
        }).catch(() => {
        });
      }
    },
    submit(){
      this.valid = 0
      this.$refs.ActivityChangeAssignItem.forEach(item=>{
        item.submit()
      })
    },
    async handleThemeRelocation(){
      const params = {
        themeDetailVOList:this.themeDetailVOList
      }
      const { data } = await gameplanApi.getGameplanThemeRelocation(params);
      if (data.resultCode === "0") {
        this.$message.success("修改成功！")
        //window.location.reload()
        this.$router.go(-1)
      }
    },
    cancel(){
      this.$router.go(-1)
    },
    getShowDetail(){
      let brandInfo = []
      let prInfo = []
      const gpPrDTOList = this.themeBasic.gpPrDTOList
      if(gpPrDTOList){
        gpPrDTOList.forEach(item=>{
          let data = ''
          if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
          else data = item.brandName||item.subBrandName
          if(brandInfo.indexOf(data)===-1) {
            brandInfo.push(data)
          }
          prInfo.push(item.prNumber+'-'+item.prName)
        })
        this.brandInfo = brandInfo.join('、')
        this.prInfo = prInfo.join('、')
      }
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    handleReset(){
      this.$confirm('是否确认重置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
      }).then(() => {
        window.location.reload()
      }).catch(() => {
      });
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #fdfdfd !important;
    border-color: #DCDFE6 !important;
    color: rgb(255, 255, 255) !important;
    cursor: not-allowed;
}
::v-deep .configure-execution .el-checkbox__input.is-checked .el-checkbox__inner,
 .configure-execution .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #a3a3a3 !important;
  border-color: #c0c0c0 !important;
}
::v-deep .el-checkbox {
    &.is-checked {
      .el-checkbox__inner {
        &::after {
          border-color: #ffffff;
        }
      }
    }
  }
.content-wrapper {

.activity_new {
  position: relative;
  margin-top: -50px;

  .activity-new-card {
    padding: 20px 10px 20px 0px;
    background-color: #ffffff;
    color: #101010;
    border-radius: 10px;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    font-family: SourceHanSansSC-bold;
    display: flex;
    justify-content: flex-start;

    .po_config_btn {
      cursor: pointer;
      position: absolute;
      right: 0;
      top: -25px;
      width: 120px;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      background-color: #539efe;
      color: #ffffff;
      font-size: 14px;
      text-align: center;
      font-family: Roboto;
    }
  }

  .activity_channel_checkbox {
    margin: -5px 0 20px 40px;
  }

  .activity_channel_checkbox_label {
    text-align: center;
    position: relative;
    top: 15px;
    line-height: 18px;
  }
}
}
.pr-box{
  width: calc(100% - 50px);
  padding: 15px 25px 15px 25px;
  background-color: #ffffff;
  border-radius: 8px;
  .pr-item{
    display: flex;
    flex-wrap: wrap;
    //margin-bottom: 12px;
  }
  .space-between{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .flex{
    display:flex;
    flex-wrap:wrap;
  }
  .pr-title{
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }
  .pr-level{
    color: white;
    display: inline-block;
    font-size: 14px;
    line-height: 18px;
    padding: 0 10px;
    background-color: rgb(71, 172, 255);
  }
  .pr-status {
    color: rgb(192, 1, 1);
    font-size: 16px;
    font-weight: 600;
  }
}
.btn_section{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 15px;
  margin-top:60px;
  text-align: center;
  .normal_btn{
    width: 100px;
    padding: 10px 0;
    border-radius: 5px;
    cursor: pointer;
  }
  .btn_bg_white{
    border: 1px solid rgb(204, 0, 0);
    color: rgb(204, 0, 0);
    margin-right: 100px;
  }
  .btn_bg_red{
    color: white;
    background-color: rgb(204, 0, 0);
    border: 1px solid rgb(204, 0, 0);
  }
}
.operation_btn_box{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: -30px 0 10px 0;
  .operate_btn{
    text-align: center;
    padding: 5px 20px;
    border-radius: 4px;
    margin: -5px 0  0 10px;
    cursor: pointer;
  }
  .operate_btn_red {
    color: white;
    background-color: rgb(214, 0, 0);
  }
  .operate_btn_white{
    color: rgb(214, 0, 0);
    background-color: white;
    border: 1px solid rgb(214, 0, 0);
  }
}
</style>
